import api from "./api";

export function handleQuizStat(questionId,bool){
    api.API.post(api.Question + `/${questionId}/bool`,{
        bool
    })
}